export default "__VITE_ASSET__Cy92V7Ra__"